const SvgMore = () => {
  return (
<svg width="150" height="116" viewBox="0 0 150 116" fill="none" >
<rect width="150" height="116" rx="22" fill="#005573"/>
<circle cx="50.5" cy="57.5" r="6.5" fill="white"/>
<circle cx="75.5" cy="57.5" r="6.5" fill="white"/>
<circle cx="100.5" cy="57.5" r="6.5" fill="white"/>
</svg>

)
}

export default SvgMore